import { useGetTagsByCategoryQuery, QuestionTagCategory } from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Table, TableContainer, type TableContainerProps } from '@shared/components';

import { QBankStructureDashBoardTableHeader } from '../../components';
import { type ItemSetQuestionPropertiesData } from '../../types';
import { getShallowestEnabledNonCourseLevel } from '../../utils';
import { QBankStructureItemSetQuestionDashboardTableBody } from '../qbank-structure-item-set-question-dashboard-table-body';

import { formatDataToQBankStructureItemSetQuestionDashboardTable } from './utils';

interface QBankStructureItemSetQuestionDashboardTableProps extends TableContainerProps {
  data: ItemSetQuestionPropertiesData[];
}
export default function QBankStructureItemSetQuestionDashboardTable(
  props: Readonly<QBankStructureItemSetQuestionDashboardTableProps>,
) {
  const { data, ...restProps } = props;
  const { qBankStructureLevelItems, qBankStructureLevels } = useQBankStructure();

  const defaultLevel = getShallowestEnabledNonCourseLevel(qBankStructureLevels);

  const { data: getDifficultyTagsResult } = useGetTagsByCategoryQuery({
    variables: { input: { category: QuestionTagCategory.Difficulty } },
  });

  const { data: getCalculationTagsResult } = useGetTagsByCategoryQuery({
    variables: { input: { category: QuestionTagCategory.Calculation } },
  });
  const formattedData = formatDataToQBankStructureItemSetQuestionDashboardTable({
    qBankStructureLevelItems,
    itemSetQuestionPropertiesData: data,
    difficultyTags: getDifficultyTagsResult?.qbsGetTagsByCategory ?? [],
    calculationTags: getCalculationTagsResult?.qbsGetTagsByCategory ?? [],
  });

  if (!defaultLevel) {
    return null;
  }

  return (
    <TableContainer
      {...restProps}
      sx={{
        overflow: 'hidden',
        ...restProps.sx,
      }}
    >
      <Table
        stickyHeader
        size='small'
        sx={{
          border: 'none',
          borderCollapse: 'initial',
          mb: '-1px',
        }}
      >
        <QBankStructureDashBoardTableHeader />
        <QBankStructureItemSetQuestionDashboardTableBody
          rows={formattedData}
          defaultLevel={defaultLevel.category}
        />
      </Table>
    </TableContainer>
  );
}
